import { PropertyType } from '../components/property/PropertyCard';

export type AgentType = {
  id: number;
  name: string;
  title: string;
  image: string;
  rating: number;
  reviews: number;
  listings: number;
  experience: string;
  specialties: string[];
  location: string;
  phone: string;
  email: string;
  agencyId?: number; // <-- ADD THIS LINE
};

export const mockAgents: AgentType[] = [
  {
    id: 1,
    name: 'Sarah Johnson',
    title: 'Senior Real Estate Agent',
    image: 'https://images.pexels.com/photos/5490276/pexels-photo-5490276.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    rating: 4.8,
    reviews: 124,
    listings: 45,
    experience: '8 years',
    specialties: ['Luxury Homes', 'Waterfront Properties'],
    location: 'New York, NY',
    phone: '+1 (555) 123-4567',
    email: 'sarah.j@dwellhub.com',
    agencyId: 1, // DwellHub Real Estate
  },
  {
    id: 2,
    name: 'Michael Rodriguez',
    title: 'Real Estate Consultant',
    image: 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    rating: 4.6,
    reviews: 98,
    listings: 32,
    experience: '5 years',
    specialties: ['First-time Buyers', 'Investment Properties'],
    location: 'Los Angeles, CA',
    phone: '+1 (555) 234-5678',
    email: 'michael.r@dwellhub.com',
    agencyId: 1, // DwellHub Real Estate
  },
  {
    id: 3,
    name: 'Emily Chen',
    title: 'Commercial Real Estate Broker',
    image: 'https://images.pexels.com/photos/3769021/pexels-photo-3769021.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    rating: 4.9,
    reviews: 150,
    listings: 60,
    experience: '10 years',
    specialties: ['Office Spaces', 'Retail Properties'],
    location: 'Chicago, IL',
    phone: '+1 (555) 345-6789',
    email: 'emily.c@dwellhub.com',
    agencyId: 2, // Prestige Properties Group
  },
  // Example of adding a new agent and assigning to agencyId 3
  {
    id: 4,
    name: 'David Miller',
    title: 'Associate Agent',
    image: 'https://images.pexels.com/photos/762020/pexels-photo-762020.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    rating: 4.5,
    reviews: 75,
    listings: 25,
    experience: '3 years',
    specialties: ['Residential Homes', 'Suburban Properties'],
    location: 'Austin, TX',
    phone: '+1 (555) 456-7890',
    email: 'david.m@homestead.com',
    agencyId: 3, // Homestead Realty Co.
  }
];

export type OfficeType = {
  city: string;
  address: string;
  phone: string;
};

export type AgencyType = {
  id: number;
  name: string;
  logoUrl: string;
  description: string;
  offices: OfficeType[];
  contactEmail: string;
  contactPhone: string;
  specialties: string[];
  rating: number;
  website?: string;
  isDeveloper?: boolean; // Optional flag to distinguish developers
};

export const mockAgencies: AgencyType[] = [
  {
    id: 1,
    name: 'DwellHub Real Estate',
    logoUrl: 'https://via.placeholder.com/150/FFC107/000000?Text=DwellHub',
    description: 'DwellHub is a leading real estate agency committed to helping our clients achieve their real estate goals through expert guidance, innovative technology, and personalized service. We have been serving the community since 2008, building a reputation for excellence and integrity.',
    offices: [
      { city: 'New York', address: '123 Madison Ave, New York, NY 10016', phone: '+1 (212) 555-0100' },
      { city: 'Los Angeles', address: '456 Wilshire Blvd, Los Angeles, CA 90036', phone: '+1 (310) 555-0101' },
    ],
    contactEmail: 'contact@dwellhub.com',
    contactPhone: '+1 (800) 555-DWELL',
    specialties: ['Luxury Homes', 'Urban Living', 'Investment Properties', 'First-time Buyers'],
    rating: 4.9,
    website: 'https://www.dwellhub-example.com',
  },
  {
    id: 2,
    name: 'Prestige Properties Group',
    logoUrl: 'https://via.placeholder.com/150/007BFF/FFFFFF?Text=Prestige',
    description: 'Prestige Properties Group specializes in high-end residential and commercial real estate. Our team of experienced professionals provides unparalleled service and market expertise.',
    offices: [
      { city: 'San Francisco', address: '789 Market St, San Francisco, CA 94103', phone: '+1 (415) 555-0200' },
      { city: 'Miami', address: '101 Ocean Dr, Miami Beach, FL 33139', phone: '+1 (305) 555-0201' },
    ],
    contactEmail: 'info@prestigepg.com',
    contactPhone: '+1 (888) PRESTIGE',
    specialties: ['Luxury Estates', 'Commercial Real Estate', 'Waterfront Properties'],
    rating: 4.7,
    website: 'https://www.prestigepg-example.com',
  },
  {
    id: 3,
    name: 'Homestead Realty Co.',
    logoUrl: 'https://via.placeholder.com/150/28A745/FFFFFF?Text=Homestead',
    description: 'Homestead Realty Co. is dedicated to finding the perfect home for families and individuals. We pride ourselves on our community focus and friendly approach.',
    offices: [
      { city: 'Austin', address: '321 Lone Star Rd, Austin, TX 78701', phone: '+1 (512) 555-0300' },
    ],
    contactEmail: 'hello@homesteadrealty.com',
    contactPhone: '+1 (800) HOMESTEAD',
    specialties: ['Residential Homes', 'Family Properties', 'Relocation Services'],
    rating: 4.5,
  },
  {
    id: 4,
    name: 'UrbanScape Developers',
    logoUrl: 'https://via.placeholder.com/150/795548/FFFFFF?Text=UrbanScape',
    description: 'UrbanScape Developers is at the forefront of innovative urban renewal and new construction projects, creating vibrant communities for modern living. We focus on sustainable design and cutting-edge architecture.',
    offices: [
      { city: 'New York', address: '555 Developer Plaza, New York, NY 10002', phone: '+1 (212) 555-DEV1' },
      { city: 'Chicago', address: '101 BuildWell Tower, Chicago, IL 60607', phone: '+1 (312) 555-DEV2' },
    ],
    contactEmail: 'projects@urbanscape.dev',
    contactPhone: '+1 (800) URBAN-DEV',
    specialties: ['Urban Redevelopment', 'Mixed-Use Properties', 'Sustainable Design', 'Luxury Condominiums'],
    rating: 4.8,
    website: 'https://www.urbanscapedev-example.com',
    isDeveloper: true,
  },
  {
    id: 5,
    name: 'Apex Construction Group',
    logoUrl: 'https://via.placeholder.com/150/FF5722/FFFFFF?Text=ApexBuild',
    description: 'Apex Construction Group has a rich history of building high-quality residential and commercial developments. Our commitment to excellence and customer satisfaction is paramount in every project we undertake.',
    offices: [
      { city: 'Austin', address: '789 Apex Circle, Austin, TX 78704', phone: '+1 (512) 555-BLD1' },
    ],
    contactEmail: 'info@apexbuild.co',
    contactPhone: '+1 (888) APEX-BLD',
    specialties: ['New Home Construction', 'Commercial Buildings', 'Master-Planned Communities'],
    rating: 4.6,
    website: 'https://www.apexbuild-example.com',
    isDeveloper: true,
  }
];

// Mock property data
export const mockProperties: PropertyType[] = [
  {
    id: 'prop1',
    title: 'Modern Apartment with City View',
    address: '123 Downtown Ave, New York, NY 10001',
    price: 750000,
    type: 'apartment',
    status: 'for sale',
    bedrooms: 2,
    bathrooms: 2,
    area: 1100,
    description: 'Stunning apartment with panoramic city views, featuring high-end finishes, an open concept layout, and a private balcony. Building amenities include a gym, pool, and 24-hour doorman.',
    images: [
      'https://images.pexels.com/photos/1918291/pexels-photo-1918291.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1457842/pexels-photo-1457842.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1643383/pexels-photo-1643383.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1743227/pexels-photo-1743227.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1648776/pexels-photo-1648776.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    ],
    isNew: true,
    agentId: 1,
  },
  {
    id: 'prop2',
    title: 'Spacious Family Home in Suburbs',
    address: '456 Maple St, Westfield, NJ 07090',
    price: 1250000,
    type: 'house',
    status: 'for sale',
    bedrooms: 4,
    bathrooms: 3.5,
    area: 2800,
    description: 'Beautiful colonial home on a quiet street, featuring a gourmet kitchen, hardwood floors throughout, finished basement, and spacious backyard with deck. Perfect for families!',
    images: [
      'https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1080721/pexels-photo-1080721.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/275484/pexels-photo-275484.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/259962/pexels-photo-259962.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    ],
    agentId: 2,
  },
  {
    id: 'prop3',
    title: 'Luxury Condo with Ocean Views',
    address: '789 Beachside Dr, Miami, FL 33139',
    price: 1850000,
    type: 'condo',
    status: 'for sale',
    bedrooms: 3,
    bathrooms: 3,
    area: 2000,
    description: 'Spectacular oceanfront condo with floor-to-ceiling windows, designer kitchen, and expansive terrace. Resort-style amenities include infinity pool, spa, and private beach access.',
    images: [
      'https://images.pexels.com/photos/2119713/pexels-photo-2119713.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/2724748/pexels-photo-2724748.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1643384/pexels-photo-1643384.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1648768/pexels-photo-1648768.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1643380/pexels-photo-1643380.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    ],
    isNew: true,
    agentId: 1,
  },
  {
    id: 'prop4',
    title: 'Charming Townhouse in Historic District',
    address: '321 Heritage Ln, Boston, MA 02108',
    price: 925000,
    type: 'townhouse',
    status: 'for sale',
    bedrooms: 3,
    bathrooms: 2.5,
    area: 1800,
    description: 'Beautifully restored townhouse in Boston\'s historic district, featuring original hardwood floors, exposed brick walls, granite countertops, and a private courtyard garden.',
    images: [
      'https://images.pexels.com/photos/1115804/pexels-photo-1115804.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1080721/pexels-photo-1080721.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1643384/pexels-photo-1643384.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1643385/pexels-photo-1643385.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1743227/pexels-photo-1743227.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    ],
    agentId: 3,
  },
  {
    id: 'prop5',
    title: 'Modern Studio Apartment',
    address: '555 Urban Ave, Chicago, IL 60611',
    price: 2500,
    type: 'apartment',
    status: 'for rent',
    bedrooms: 0,
    bathrooms: 1,
    area: 550,
    description: 'Sleek studio apartment in prime downtown location, featuring modern furnishings, stainless steel appliances, and floor-to-ceiling windows with city views. Perfect for young professionals.',
    images: [
      'https://images.pexels.com/photos/1743231/pexels-photo-1743231.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1457842/pexels-photo-1457842.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1643383/pexels-photo-1643383.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1743227/pexels-photo-1743227.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1648776/pexels-photo-1648776.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    ],
    agentId: 2,
  },
  {
    id: 'prop6',
    title: 'Luxury Penthouse with Rooftop Terrace',
    address: '888 Skyline Blvd, San Francisco, CA 94111',
    price: 3500000,
    type: 'condo',
    status: 'for sale',
    bedrooms: 3,
    bathrooms: 3.5,
    area: 2800,
    description: 'Breathtaking penthouse with panoramic views of the bay, featuring a chef\'s kitchen, marble bathrooms, and a private rooftop terrace with hot tub. Building amenities include concierge, gym, and wine cellar.',
    images: [
      'https://images.pexels.com/photos/2102587/pexels-photo-2102587.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1457842/pexels-photo-1457842.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1648771/pexels-photo-1648771.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/276551/pexels-photo-276551.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    ],
    agentId: 1,
  },
  {
    id: 'prop7',
    title: 'Cozy Cottage with Garden',
    address: '222 Hillside Way, Portland, OR 97201',
    price: 575000,
    type: 'house',
    status: 'for sale',
    bedrooms: 2,
    bathrooms: 1,
    area: 1100,
    description: 'Charming cottage in a peaceful neighborhood, featuring a remodeled kitchen, cozy fireplace, and beautiful garden with mature fruit trees. Perfect for first-time homebuyers or downsizers.',
    images: [
      'https://images.pexels.com/photos/2079234/pexels-photo-2079234.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/275484/pexels-photo-275484.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1643384/pexels-photo-1643384.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1743227/pexels-photo-1743227.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1648776/pexels-photo-1648776.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    ],
    isNew: true,
    // No agentId for this one
  },
  {
    id: 'prop8',
    title: 'Luxury Apartment with Pool',
    address: '777 Lakeview Dr, Austin, TX 78701',
    price: 3200,
    type: 'apartment',
    status: 'for rent',
    bedrooms: 2,
    bathrooms: 2,
    area: 1300,
    description: 'High-end apartment with luxurious finishes, featuring an open floor plan, walk-in closets, and private balcony. Community amenities include resort-style pool, fitness center, and clubhouse.',
    images: [
      'https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1457842/pexels-photo-1457842.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1643383/pexels-photo-1643383.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1743227/pexels-photo-1743227.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1648776/pexels-photo-1648776.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    ],
    agentId: 3,
  },
  {
    id: 'prop9',
    title: 'Waterfront House with Dock',
    address: '123 Shoreline Rd, Tampa, FL 33616',
    price: 1750000,
    type: 'house',
    status: 'pending',
    bedrooms: 4,
    bathrooms: 4,
    area: 3200,
    description: 'Stunning waterfront property with private dock, featuring an open floor plan, gourmet kitchen, pool, and expansive patio for entertaining. Incredible sunset views over the bay.',
    images: [
      'https://images.pexels.com/photos/1438832/pexels-photo-1438832.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/2724748/pexels-photo-2724748.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1643384/pexels-photo-1643384.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1648768/pexels-photo-1648768.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1643380/pexels-photo-1643380.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    ],
    agentId: 1,
  },
  {
    id: 'prop10',
    title: 'Historic Brownstone with Garden',
    address: '567 Heritage St, Brooklyn, NY 11215',
    price: 2950000,
    type: 'townhouse',
    status: 'for sale',
    bedrooms: 4,
    bathrooms: 3,
    area: 3000,
    description: 'Meticulously restored 19th-century brownstone with original architectural details, featuring high ceilings, fireplaces, a chef\'s kitchen, and a private garden. Located in a prime historic district.',
    images: [
      'https://images.pexels.com/photos/1029599/pexels-photo-1029599.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1080721/pexels-photo-1080721.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/275484/pexels-photo-275484.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/259962/pexels-photo-259962.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    ],
    isNew: true,
    agentId: 2,
  },
  {
    id: 'prop11',
    title: 'Modern Loft in Arts District',
    address: '789 Creative Ave, Los Angeles, CA 90013',
    price: 875000,
    type: 'condo',
    status: 'for sale',
    bedrooms: 1,
    bathrooms: 2,
    area: 1500,
    description: 'Industrial-chic loft with soaring ceilings, exposed brick, and oversized windows. Features include custom built-ins, high-end appliances, and a rooftop deck with city views.',
    images: [
      'https://images.pexels.com/photos/2079249/pexels-photo-2079249.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1457842/pexels-photo-1457842.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1643383/pexels-photo-1643383.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1743227/pexels-photo-1743227.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1648776/pexels-photo-1648776.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    ],
    agentId: 3,
  },
  {
    id: 'prop12',
    title: 'Family House with Backyard',
    address: '345 Suburban Ln, Denver, CO 80209',
    price: 1050000,
    type: 'house',
    status: 'for sale',
    bedrooms: 5,
    bathrooms: 3.5,
    area: 3500,
    description: 'Spacious family home in a sought-after neighborhood, featuring an updated kitchen, master suite with walk-in closet, finished basement, and large backyard with covered patio.',
    images: [
      'https://images.pexels.com/photos/259588/pexels-photo-259588.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1080721/pexels-photo-1080721.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/275484/pexels-photo-275484.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/259962/pexels-photo-259962.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      'https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    ],
    // No agentId for this one
  },
];

// Featured properties - a subset of the mock properties with the isFeatured flag
export const mockFeaturedProperties: PropertyType[] = [
  {
    ...mockProperties[2],
    id: 'feat1',
    isFeatured: true,
  },
  {
    ...mockProperties[5],
    id: 'feat2',
    isFeatured: true,
  },
  {
    ...mockProperties[8],
    id: 'feat3',
    isFeatured: true,
    status: 'for sale', // override to show as available
  },
  {
    ...mockProperties[9],
    id: 'feat4',
    isFeatured: true,
  },
  {
    ...mockProperties[0],
    id: 'feat5',
    isFeatured: true,
  },
  {
    ...mockProperties[11],
    id: 'feat6',
    isFeatured: true,
  },
];

// New UnitType Interface
export interface UnitType {
  id: string;
  unitName: string;
  bedrooms: number;
  bathrooms: number;
  area: number; // in sq ft or sq m
  price: number;
  availability: string; // e.g., "Available", "Sold", "Reserved"
  unitDescription?: string; // e.g., "Spacious corner unit with panoramic city views and a private balcony."
  floorPlans?: { type: '2D' | '3D'; url: string; description?: string }[];
}

// New DevelopmentProjectType Interface
export interface DevelopmentProjectType {
  id: string;
  companyName: string;
  projectName: string;
  projectDescription: string;
  location: string;
  imageUrl: string;
  status: string; // e.g., "Under Construction", "Now Selling", "Completed"
  launchDate: string; // e.g., "Q4 2024", "January 2025"
  expectedCompletionDate: string; // e.g., "Q2 2026"
  units: UnitType[];
  projectLevelPlans?: string[]; // e.g., ["Advanced Thermal Isolation", "High-Speed Elevator Access"]
  sitePlanImages?: { type: '2D' | '3D'; url: string; description?: string }[];
  developingCompanyAgencyId?: number;
}

// Mock Development Projects Data
export const mockDevelopmentProjects: DevelopmentProjectType[] = [
  {
    id: "devProj1",
    companyName: "Greenwood Developers",
    projectName: "Azure Heights",
    projectDescription: "Azure Heights offers a blend of luxury and comfort with stunning city views and state-of-the-art amenities. Located in the heart of downtown, it's an ideal choice for urban dwellers.",
    location: "New York, NY",
    imageUrl: "https://images.pexels.com/photos/1105766/pexels-photo-1105766.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    status: "Now Selling",
    launchDate: "Q1 2024",
    expectedCompletionDate: "Q4 2025",
    projectLevelPlans: ["LEED Certified Gold", "Smart Home Integration", "Rooftop Terrace with Pool"],
    sitePlanImages: [
      { type: '2D', url: "https://via.placeholder.com/800x600.png?text=Azure+Heights+Site+Plan+2D", description: "Overall site layout - 2D" },
      { type: '3D', url: "https://via.placeholder.com/800x600.png?text=Azure+Heights+Site+Plan+3D", description: "Aerial view of the completed project - 3D" }
    ],
    developingCompanyAgencyId: 4, // UrbanScape Developers
    units: [
      { id: "unitA101", unitName: "Apartment 101", bedrooms: 1, bathrooms: 1, area: 750, price: 550000, availability: "Available", unitDescription: "Cozy one-bedroom with modern finishes and city skyline views.", floorPlans: [{type: '2D', url: "https://via.placeholder.com/600x400.png?text=A101+2D"}, {type: '3D', url: "https://via.placeholder.com/600x400.png?text=A101+3D"}] },
      { id: "unitA102", unitName: "Apartment 102", bedrooms: 2, bathrooms: 2, area: 1100, price: 850000, availability: "Sold", unitDescription: "Spacious two-bedroom, ideal for small families or professionals needing a home office.", floorPlans: [{type: '2D', url: "https://via.placeholder.com/600x400.png?text=A102+2D"}] },
      { id: "unitA201", unitName: "Apartment 201", bedrooms: 2, bathrooms: 2.5, area: 1250, price: 950000, availability: "Reserved", unitDescription: "Luxurious dual-master suite with large balcony and premium appliances.", floorPlans: [{type: '3D', url: "https://via.placeholder.com/600x400.png?text=A201+3D", description: "Interactive 3D walkthrough model"}] },
      { id: "unitPH01", unitName: "Penthouse 01", bedrooms: 3, bathrooms: 3.5, area: 2200, price: 2500000, availability: "Available", unitDescription: "Exclusive penthouse with panoramic views, private elevator access, and expansive terrace.", floorPlans: [{type: '2D', url: "https://via.placeholder.com/600x400.png?text=PH01+2D"}, {type: '3D', url: "https://via.placeholder.com/600x400.png?text=PH01+3D"}] },
    ],
  },
  {
    id: "devProj2",
    companyName: "Pinnacle Estates",
    projectName: "Willow Creek Residences",
    projectDescription: "Discover serene living at Willow Creek Residences, a collection of modern townhouses nestled in a lush, green landscape. Perfect for families seeking tranquility and space.",
    location: "Austin, TX",
    imageUrl: "https://images.pexels.com/photos/209315/pexels-photo-209315.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    status: "Under Construction",
    launchDate: "Q3 2024",
    expectedCompletionDate: "Q1 2026",
    projectLevelPlans: ["Community Clubhouse", "Walking Trails", "Eco-friendly Landscaping", "Gated Community"],
    sitePlanImages: [
      { type: '2D', url: "https://via.placeholder.com/800x600.png?text=Willow+Creek+Site+Plan", description: "Community layout with amenities" }
    ],
    developingCompanyAgencyId: 5, // Apex Construction Group
    units: [
      { id: "unitWC01", unitName: "Townhouse A", bedrooms: 3, bathrooms: 2.5, area: 1800, price: 650000, availability: "Available", unitDescription: "Family-friendly townhouse with private garden and open-plan living area.", floorPlans: [{type: '2D', url: "https://via.placeholder.com/600x400.png?text=WC01+2D"}] },
      { id: "unitWC02", unitName: "Townhouse B", bedrooms: 4, bathrooms: 3, area: 2200, price: 780000, availability: "Available", unitDescription: "Large four-bedroom unit with bonus room, perfect for growing families.", floorPlans: [{type: '2D', url: "https://via.placeholder.com/600x400.png?text=WC02+2D"}, {type: '3D', url: "https://via.placeholder.com/600x400.png?text=WC02+3D"}] },
      { id: "unitWC03", unitName: "Townhouse C", bedrooms: 3, bathrooms: 2.5, area: 1850, price: 670000, availability: "Reserved", unitDescription: "Modern design with high ceilings and energy-efficient windows.", floorPlans: [{type: '2D', url: "https://via.placeholder.com/600x400.png?text=WC03+2D"}] },
      { id: "unitWC04", unitName: "Townhouse D (Corner)", bedrooms: 4, bathrooms: 3.5, area: 2400, price: 850000, availability: "Sold", unitDescription: "Premium corner lot with extra windows and upgraded finishes.", floorPlans: [{type: '3D', url: "https://via.placeholder.com/600x400.png?text=WC04+3D"}] },
      { id: "unitWC05", unitName: "Townhouse E", bedrooms: 2, bathrooms: 2, area: 1500, price: 550000, availability: "Available", unitDescription: "Charming two-bedroom, ideal for first-time homebuyers or downsizing.", floorPlans: [{type: '2D', url: "https://via.placeholder.com/600x400.png?text=WC05+2D"}] },
    ],
  },
  {
    id: "devProj3",
    companyName: "Horizon Builders Inc.",
    projectName: "Sunset Vista Condos",
    projectDescription: "Experience breathtaking sunset views from your modern condo at Sunset Vista. Featuring contemporary design, premium finishes, and a vibrant community atmosphere.",
    location: "San Diego, CA",
    imageUrl: "https://images.pexels.com/photos/164558/pexels-photo-164558.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    status: "Completed",
    launchDate: "Q2 2023",
    expectedCompletionDate: "Q4 2024",
    projectLevelPlans: ["Ocean Views for All Units", "Private Beach Access", "Fitness Center and Spa"],
    sitePlanImages: [
      { type: '3D', url: "https://via.placeholder.com/800x600.png?text=Sunset+Vista+3D+Model", description: "3D rendering of the completed condo complex" }
    ],
    developingCompanyAgencyId: 4, // UrbanScape Developers (can also re-use or use one of the original if they fit)
    units: [
      { id: "unitSV10A", unitName: "Condo 10A", bedrooms: 1, bathrooms: 1, area: 800, price: 480000, availability: "Sold", unitDescription: "Compact one-bedroom with stunning ocean views.", floorPlans: [{type: '2D', url: "https://via.placeholder.com/600x400.png?text=SV10A+2D"}] },
      { id: "unitSV12B", unitName: "Condo 12B", bedrooms: 2, bathrooms: 2, area: 1150, price: 720000, availability: "Available", unitDescription: "Two-bedroom unit with large balcony overlooking the Pacific.", floorPlans: [{type: '2D', url: "https://via.placeholder.com/600x400.png?text=SV12B+2D"}, {type: '3D', url: "https://via.placeholder.com/600x400.png?text=SV12B+3D"}] },
      { id: "unitSV15C", unitName: "Condo 15C (Corner)", bedrooms: 3, bathrooms: 2, area: 1500, price: 980000, availability: "Sold", unitDescription: "Spacious corner three-bedroom unit with wrap-around windows and premium finishes.", floorPlans: [{type: '3D', url: "https://via.placeholder.com/600x400.png?text=SV15C+3D"}] },
    ],
  },
];

// Chat Interfaces and Mock Data

export type ChatMessage = {
  id: string;
  text: string;
  sender: 'user' | 'assistant';
  timestamp: Date;
};

export type Conversation = {
  id: string;
  title: string;
  messages: ChatMessage[];
  lastUpdated: Date;
  // lastMessageSnippet?: string; // Optional, can be added later if needed
};

export const mockConversations: Conversation[] = [
  {
    id: 'convo1',
    title: 'Looking for a 3-bedroom house in Austin',
    messages: [
      { id: 'msg1-1', text: "Hi, I'm looking for a 3-bedroom house in Austin, TX with a budget around $700k.", sender: 'user', timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2) }, // 2 hours ago
      { id: 'msg1-2', text: "Hello! I can certainly help with that. Are there any specific neighborhoods in Austin you're interested in, or particular features you're looking for (e.g., large backyard, updated kitchen)?", sender: 'assistant', timestamp: new Date(Date.now() - 1000 * 60 * 59 * 2) }, // 1h 58m ago
      { id: 'msg1-3', text: "We like the Zilker and Barton Hills areas. A good school district is important, and we'd prefer a newer build or something recently renovated.", sender: 'user', timestamp: new Date(Date.now() - 1000 * 60 * 30) }, // 30 mins ago
      { id: 'msg1-4', text: "Great choices! Zilker and Barton Hills are known for their excellent schools and amenities. I'll compile a list of available 3-bedroom homes in those areas that match your criteria and budget. I'll get back to you shortly.", sender: 'assistant', timestamp: new Date(Date.now() - 1000 * 60 * 28) }, // 28 mins ago
    ],
    lastUpdated: new Date(Date.now() - 1000 * 60 * 28),
  },
  {
    id: 'convo2',
    title: 'Question about property ID prop3 viewing',
    messages: [
      { id: 'msg2-1', text: "I'd like to schedule a viewing for the property at 789 Beachside Dr, Miami (ID: prop3). Is it still available?", sender: 'user', timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2) }, // 2 days ago
      { id: 'msg2-2', text: "Let me check the status of the Luxury Condo with Ocean Views (prop3) for you. One moment.", sender: 'assistant', timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2 + 1000 * 60 * 2) }, // 2 days ago + 2 mins
      { id: 'msg2-3', text: "Good news! The property is still listed as 'for sale'. When would you be available for a viewing? We generally need 24-hour notice for occupied properties.", sender: 'assistant', timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24 * 2 + 1000 * 60 * 5) }, // 2 days ago + 5 mins
      { id: 'msg2-4', text: "How about this Saturday afternoon, around 2 PM?", sender: 'user', timestamp: new Date(Date.now() - 1000 * 60 * 30) }, // 30 mins ago
      { id: 'msg2-5', text: "Saturday at 2 PM should work. I'll confirm with the seller's agent and get back to you with the confirmation details shortly.", sender: 'assistant', timestamp: new Date(Date.now() - 1000 * 60 * 25) }, // 25 mins ago
    ],
    lastUpdated: new Date(Date.now() - 1000 * 60 * 25),
  },
  {
    id: 'convo3',
    title: 'Rental application process',
    messages: [
      { id: 'msg3-1', text: "What documents do I need to submit for a rental application?", sender: 'user', timestamp: new Date(Date.now() - 1000 * 60 * 15) }, // 15 mins ago
      { id: 'msg3-2', text: "Typically, you'll need a completed application form, proof of income (like pay stubs or bank statements), a copy of your ID, and sometimes a credit report check authorization. Specific requirements can vary by property.", sender: 'assistant', timestamp: new Date(Date.now() - 1000 * 60 * 14) }, // 14 mins ago
      { id: 'msg3-3', text: "Okay, thank you for the information!", sender: 'user', timestamp: new Date(Date.now() - 1000 * 60 * 10) }, // 10 mins ago
    ],
    lastUpdated: new Date(Date.now() - 1000 * 60 * 10),
  }
];